"use client"

import { MediaSelect } from "@/(admin)/modules/media/pages/SelectMediaUIBuilder"
import { ComponentConfig } from "@measured/puck"
import { QuickLinksProps } from "../../../../../../../types/types"
import { RenderConfig } from "./RenderConfig"

export const QuickLinks: ComponentConfig<QuickLinksProps> = {
  label: "Tamda Group | Quick Links",
  fields: {
    links: {
      label: "Quick Links",
      type: "array",
      arrayFields: {
        title: {
          label: "Title",
          type: "text",
        },
        description: {
          label: "Description",
          type: "textarea",
        },
        image: {
          label: "Image",
          type: "custom",
          render: (props: any) => <MediaSelect {...props} />,
        },
        link: {
          label: "Link",
          type: "text",
        },
      },
    },
  },
  defaultProps: {
    links: [
      {
        title: "Về tập đoàn",
        description: "Tìm hiểu về lịch sử, tầm nhìn và giá trị cốt lõi của TAMDA GROUP",
        image: "",
        link: "/about-us",
      },
      {
        title: "TAMDA FOODS",
        description: "Khám phá các sản phẩm thực phẩm chất lượng cao từ TAMDA FOODS",
        image: "",
        link: "/tamda-foods",
      },
      {
        title: "TTTM TAMDA",
        description: "Trải nghiệm không gian mua sắm hiện đại tại Trung tâm thương mại TAMDA",
        image: "",
        link: "/tttm-tamda",
      },
    ],
  },
  ...RenderConfig,
}
